export default {
    name: 'TriangleFill',
    dimensions: { width: 22, height: 20 },
    content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C10.0318 0 9.12273 0.511955 8.63014 1.34944L0.652817 14.6249L0.648462 14.6323C0.229233 15.3437 0 16.1687 0 17C0 18.6523 1.34772 20 3 20H19C20.6523 20 22 18.6523 22 17C22 16.172 21.7723 15.3414 21.3343 14.6303L13.3701 1.34986C12.8776 0.512125 11.9683 0 11 0Z" fill="currentColor"/>
  `
};
